// import CookieBanner from '@amzn/carrier-logistics-common-ui-assets/dist/components/Molecules/CookieBanner';
import { BUTTON_CLICK } from '@amzn/carrierlogistics-commons/dist/constants/analytics';
import { DEVICE_WIDTHS } from '@amzn/carrierlogistics-commons/dist/constants/breakpoints';
import { recordCustomEventInCloudWatchRUM } from '@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum';
import Button from '@amzn/meridian/button';
import Responsive from '@amzn/meridian/responsive';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  PRIVACY_POLICY_PATH,
  TERMS_PATH,
} from '../../config/navigationalRoutes';
import {
  CONDITIONS_OF_USE_BUTTON,
  PRIVACY_NOTICE_BUTTON,
} from '../../constants/analytics';
import useNavigateToSpecifiedRoute from '../../hooks/useNavigateToSpecifiedRoute';

const Footer = () => {
  const { navigateToSpecifiedRoute } = useNavigateToSpecifiedRoute();
  const onConditionsOfUseClick = useCallback(() => {
    navigateToSpecifiedRoute(TERMS_PATH);
    recordCustomEventInCloudWatchRUM(BUTTON_CLICK, {
      action_properties: {
        name: CONDITIONS_OF_USE_BUTTON,
      },
    });
  }, [navigateToSpecifiedRoute]);

  const onPrivacyNoticeClick = useCallback(() => {
    navigateToSpecifiedRoute(PRIVACY_POLICY_PATH);
    recordCustomEventInCloudWatchRUM(BUTTON_CLICK, {
      action_properties: {
        name: PRIVACY_NOTICE_BUTTON,
      },
    });
  }, [navigateToSpecifiedRoute]);
  const fontSizeForFooter = useMemo(() => ({ fontSize: '12px' }), []);
  return (
    <>
      <Row alignmentHorizontal="center" wrap="down">
        <Button type="link" onClick={onConditionsOfUseClick}>
          <div style={fontSizeForFooter}>
            <FormattedMessage id="home_page.footer.conditions_of_use_button" />
          </div>
        </Button>
        <Button type="link" onClick={onPrivacyNoticeClick}>
          <div style={fontSizeForFooter}>
            <FormattedMessage id="home_page.footer.privacy_notice_button" />
          </div>
        </Button>
        <Responsive
          query="min-width"
          props={{
            label: {
              default: '',
              [DEVICE_WIDTHS.TABLET]: '|',
            },
          }}
        >
          {({ label }) => <Text>{label}</Text>}
        </Responsive>

        <Text>
          <div style={fontSizeForFooter}>
            <FormattedMessage id="home_page.footer.copyright_text" />
          </div>
        </Text>
      </Row>
      {/* Todo : Legal team to provide navigation URL */}
      {/* <CookieBanner /> */}
    </>
  );
};

export default Footer;
